import { render } from "./EventBrandingEditor.vue?vue&type=template&id=679871fa&scoped=true"
import script from "./EventBrandingEditor.vue?vue&type=script&lang=js"
export * from "./EventBrandingEditor.vue?vue&type=script&lang=js"

import "./EventBrandingEditor.vue?vue&type=style&index=0&id=679871fa&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679871fa"]])

export default __exports__